import { Component, OnInit } from '@angular/core';

import { EventEmitter } from '@angular/core';
import { MaterializeAction } from 'angular2-materialize';
import { ThemeService } from './theme.service';
import { ToastrService } from 'ngx-toastr';
//import { MessagingService } from './../messaging.service'
@Component({
  selector: 'app-theme',
  templateUrl: './theme.component.html',
  styleUrls: ['./theme.component.css']
})
export class ThemeComponent implements OnInit {
busy: Promise<any>;
modalActions = new EventEmitter<string|MaterializeAction>();
admin_contact_message:String="";
  constructor( 
    private klassService: ThemeService,
    private toastr: ToastrService,
   // public msg: MessagingService, public auth: AuthService
) { }

  ngOnInit() {
  //   this.auth.user
  //   .filter(user => !!user) // filter null
  //   .take(1) // take first real user
  //   .subscribe(user => {
  //     if (user) {
  //       this.msg.getPermission(user)
  //       this.msg.monitorRefresh(user)
  //       this.msg.receiveMessages()
  //     }
  //   })
  // }
  
  }

  openChatModal() { 
    //this.item = _item;
   // this.action = action;
    this.modalActions.emit({ action:"modal", params:['open'] });

  }

  adminSupport(){
  	let obj={"question":this.admin_contact_message};
 
     this.busy =this.klassService.adminSupport(obj, 'adminsupport').then((res) => {
      if(!res)
        return true;      
        this.admin_contact_message="";
     this.toastr.success(res.msg);
     setTimeout(()=>{    //<<<---    using ()=> syntax
	      this.closeChatModal();
	 },200);
    //this.alertsService.notify('success', res.msg);
    });
  }

  closeChatModal() {
    this.modalActions.emit({ action:"modal", params:['close'] });
  }
}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/theme/theme.component.ts